import { EXTEND_SKU } from '../../data/constants'
import { EXTEND_LOGO } from '../../helpers/checkoutHelpers'
import zgoldLogo from '@/statics/images/zgold-logo.svg'
import { getCookieByName } from '@/helpers/common'
import { FEATURE_TOGGLES, WUNDERKIND_ID } from '@/services/Configuration'
import { error } from '../Log'

// TODO: This should be passed as env_var
const LISTRAK_ID = 'T6phidacCJdz'

const getIsLoyaltyProgramEnabled = () => {
  const isLoyaltyProgramEnabled = FEATURE_TOGGLES?.isLoyaltyProgramEnabled
  try {
    const isLoyaltyCookieEnabled = getCookieByName('enableRewards') === 'true'
    return isLoyaltyProgramEnabled || isLoyaltyCookieEnabled
  } catch (e) {
    error(e)
  }
  //fallback
  return isLoyaltyProgramEnabled
}
// Branding
// eslint-disable-next-line import/prefer-default-export
export const getBranding = async () => ({
  brandName: 'One Kings Lane',
  logoUrl: 'https://assets.onekingslane.com/m/2a3672007ee7fa59/original/OKL-logo-reg.png',
  themeName: 'okl',
  desktopLogoSvg: 'https://assets.onekingslane.com/m/2a3672007ee7fa59/original/OKL-logo-reg.png',
  mobileLogoSvg: 'https://assets.onekingslane.com/m/62954f1b3cd8439b/original/OKL2018_Elephant_K.png',
  listrak: LISTRAK_ID,
  extendSku: EXTEND_SKU,
  extendLogo: EXTEND_LOGO,
  zgoldLogo,
  FEATURE_TOGGLES: { ...FEATURE_TOGGLES, isLoyaltyProgramEnabled: getIsLoyaltyProgramEnabled() } ?? {},
  wunderkindId: WUNDERKIND_ID
  /*
    for theme-zg vs theme-okl, eventually allow client to
    provide JSON object with primary, secondary, etc. colors
    and font choices.
  */
})
